import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { pdfStyles } from '../PDFStyles';

interface MetricsSectionProps {
  forecast: any;
  reputationInfo: {
    level: string;
    color: string;
  };
  uiScore: number;
}

// Helper function to get confidence color
const getConfidenceColor = (confidence?: string | null) => {
  switch (confidence?.toLowerCase()) {
    case 'high': return '#06D6A0';
    case 'medium': return '#FFD166';
    case 'low': return '#FF6B6B';
    default: return '#FF6B6B';
  }
};

export const MetricsSection: React.FC<MetricsSectionProps> = ({ 
  forecast, 
  reputationInfo, 
  uiScore 
}) => {
  return (
    <View style={pdfStyles.gridContainer}>
      {/* Reputation Impact */}
      <View style={pdfStyles.gridItem}>
        <View style={pdfStyles.metricCard}>
          <Text style={pdfStyles.metricCardTitle}>Reputation Impact</Text>
          <Text style={[pdfStyles.metricValue, { color: reputationInfo.color }]}>
            {Math.round(uiScore)}%
          </Text>
          <Text style={pdfStyles.metricLabel}>{reputationInfo.level}</Text>
        </View>
      </View>

      {/* Sentiment Analysis */}
      <View style={pdfStyles.gridItem}>
        <View style={pdfStyles.metricCard}>
          <Text style={pdfStyles.metricCardTitle}>Sentiment Analysis</Text>
          <View style={pdfStyles.sentimentPercentageBreakdown}>
            <View style={pdfStyles.sentimentPercentageRow}>
              <View style={[pdfStyles.sentimentDot, { backgroundColor: '#06D6A0' }]} />
              <Text style={[pdfStyles.sentimentPercentageValue, { color: '#06D6A0' }]}>
                {forecast?.positivePct || 0}%
              </Text>
              <Text style={pdfStyles.sentimentPercentageLabel}>Positive</Text>
            </View>
            <View style={pdfStyles.sentimentPercentageRow}>
              <View style={[pdfStyles.sentimentDot, { backgroundColor: '#AAAAAA' }]} />
              <Text style={[pdfStyles.sentimentPercentageValue, { color: '#AAAAAA' }]}>
                {forecast?.neutralPct || 0}%
              </Text>
              <Text style={pdfStyles.sentimentPercentageLabel}>Neutral</Text>
            </View>
            <View style={pdfStyles.sentimentPercentageRow}>
              <View style={[pdfStyles.sentimentDot, { backgroundColor: '#FF6B6B' }]} />
              <Text style={[pdfStyles.sentimentPercentageValue, { color: '#FF6B6B' }]}>
                {forecast?.negativePct || 0}%
              </Text>
              <Text style={pdfStyles.sentimentPercentageLabel}>Negative</Text>
            </View>
          </View>
        </View>
      </View>

      {/* Forecast Confidence */}
      <View style={pdfStyles.gridItemLast}>
        <View style={pdfStyles.metricCard}>
          <Text style={pdfStyles.metricCardTitle}>Forecast Confidence</Text>
          <Text style={[pdfStyles.metricValue, { color: getConfidenceColor(forecast?.confidence || 'Low') }]}>
            {forecast?.confidence || 'Low'}
          </Text>
          <Text style={pdfStyles.metricLabel}>
            {forecast?.confidence === 'High' && 'Strong consensus in prediction'}
            {forecast?.confidence === 'Medium' && 'Moderate agreement in prediction'}
            {(forecast?.confidence === 'Low' || !forecast?.confidence) && 'Limited consensus in prediction'}
          </Text>
        </View>
      </View>
    </View>
  );
};